import React, { useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function DoctorProfileChart({ pending, active, scheduled, cancelled, Completed, Missed}: { 
    pending: number, 
    active: number, 
    scheduled: number, 
    cancelled: number,
    Completed: number,
    Missed: number
}) {
    // Calculate total and percentages as integers
    const total = scheduled + active + pending + cancelled + Completed + Missed;
    const scheduledPercentage = total ? Math.round((scheduled / total) * 100) : 0;
    const activePercentage = total ? Math.round((active / total) * 100) : 0;
    const pendingPercentage = total ? Math.round((pending / total) * 100) : 0;
    const cancelledPercentage = total ? Math.round((cancelled / total) * 100) : 0;
    const completedPercentage = total ? Math.round((Completed / total) * 100) : 0;
    const missedPercentage = total ? Math.round((Missed / total) * 100) : 0;

    const data = {
        labels: ['Scheduled', 'Active', 'Confirmed', 'Cancelled', 'Completed', 'Missed'],
        datasets: [
            {
                label: 'Appointments ',
                data: [scheduledPercentage, activePercentage, pendingPercentage, cancelledPercentage, completedPercentage, missedPercentage],
                backgroundColor: [
                    '#3B82F6',  // Scheduled - Blue (bg-blue-500)
                    '#10B981',  // Active - Green (bg-green-500) 
                    '#F59E0B',  // Confirmed - Amber (bg-amber-500)
                    '#EF4444',  // Cancelled - Red (bg-red-500)
                    '#059669',  // Completed - Emerald (bg-emerald-500)
                    '#F97316'   // Missed - Orange (bg-orange-500)
                ],
                borderColor: [
                    '#3B82F6',  // Scheduled - Blue
                    '#10B981',  // Active - Green
                    '#F59E0B',  // Confirmed - Amber
                    '#EF4444',  // Cancelled - Red
                    '#059669',  // Completed - Emerald
                    '#F97316'   // Missed - Orange
                ],
                borderWidth: 3,
                spacing: 4
            },
        ],
    };
    
    const options = {
        responsive: true,
        cutout: 85,
        plugins: {
            legend: {
                position: 'bottom' as const,
                align: 'center' as const,
                labels: {
                    usePointStyle: true,
                    pointStyle: 'rect',
                    padding: 15,
                    font: {
                        size: 12,
                        family: 'Arial, sans-serif'
                    },
                    color: '#333',
                    boxWidth: 12,
                    boxHeight: 12
                },
                maxWidth: 400,
                display: true
            },
            tooltip: {
                enabled: true,
                callbacks: {
                    label: function(context: any) {
                        const label = context.label || '';
                        const value = context.parsed;
                        return `${label}: ${value}%`;
                    }
                }
            },
        },
        layout: {
            padding: {
                bottom: 20
            }
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
            <Doughnut data={data} options={options} />
        </div>
    );
}
